import { withInstall } from '@lit-element/utils'
import Calendar from './src/calendar.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCalendar: SFCWithInstall<typeof Calendar> = withInstall(Calendar)
export default LtCalendar

export * from './src/calendar'
export type {
  CalendarDateTableInstance,
  DateTableInstance,
  CalendarInstance,
} from './src/instance'
